module.exports = __webpack_public_path__ + "static/lugano-living-lab-logo-715ba2a546981aad682f0af3124900d6.png";